<template>
	<div style="overflow-x: hidden;overflow-y: hidden;">
		<navbar></navbar>
		<div id="box">
			<div style="width: 100%;">
				<center><h1 style="font-size: 1.75rem;padding-top: 1.25rem;">{{$t('autominer.title')}}</h1></center>
				<br />
				<center><span style="color: #909399;">{{$t('autominer.title_desc')}}</span></center>
			</div>
			<el-divider></el-divider>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div style="width: 80%;margin: auto;">
						<el-collapse accordion v-model="activeName" style="border: 1px solid #ebebeb;border-radius: 3px;transition: .2s;">
							<el-collapse-item name="1">
								<template slot="title">
									<span style="text-align: center;margin-left: 1rem;">{{$t('autominer.win')}}</span>
								</template>
								<div style="width: 80%;margin: auto;">
									<el-form label-position="top" label-width="80px" :rules="rules" ref="formdata" :model="formdata">
										<el-form-item :label="$t('autominer.wallet_address')" prop="wallet"><el-input v-model="formdata.wallet" :placeholder="$t('wallet_input')"></el-input></el-form-item>
										<el-form-item :label="$t('autominer.minername')" prop="minername"><el-input v-model="formdata.minerName" :placeholder="$t('minername_input')"></el-input></el-form-item>
										<el-form-item>
											<center><el-button type="primary" @click="onSubmit('formdata')">{{$t('autominer.ljsc')}}</el-button></center>
										</el-form-item>
									</el-form>
								</div>
							</el-collapse-item>
							<el-collapse-item name="2">
								<template slot="title">
									<span style="text-align: center;margin-left: 1rem;">{{$t('autominer.linux')}}</span>
								</template>
								<div style="width: 80%;margin: auto;">
									<el-form label-position="top" label-width="80px" :rules="rules" ref="formdata" :model="formdata">
										<el-form-item :label="$t('autominer.wallet_address')" prop="wallet"><el-input v-model="formdata.wallet" :placeholder="$t('wallet_input')"></el-input></el-form-item>
										<el-form-item :label="$t('autominer.minername')" prop="minername"><el-input v-model="formdata.minerName" :placeholder="$t('minername_input')"></el-input></el-form-item>
										<el-form-item>
											<center><el-button type="primary" @click="onSubmit('formdata')">{{$t('autominer.ljsc')}}</el-button></center>
										</el-form-item>
									</el-form>
								</div>
							</el-collapse-item>
							<el-collapse-item name="3">
								<template slot="title">
									<span style="text-align: center;margin-left: 1rem;">{{$t('autominer.mac')}}</span>
								</template>
								<div style="width: 80%;margin: auto;">
									<el-form label-position="top" label-width="80px" :rules="rules" ref="formdata" :model="formdata">
										<el-form-item :label="$t('autominer.wallet_address')" prop="wallet"><el-input v-model="formdata.wallet" :placeholder="$t('wallet_input')"></el-input></el-form-item>
										<el-form-item :label="$t('autominer.minername')" prop="minername"><el-input v-model="formdata.minerName" :placeholder="$t('minername_input')"></el-input></el-form-item>
										<el-form-item>
											<center><el-button type="primary" @click="onSubmit('formdata')">{{$t('autominer.ljsc')}}</el-button></center>
										</el-form-item>
									</el-form>
								</div>
							</el-collapse-item>
							<!-- <el-collapse-item name="4">
								<template slot="title">
									<span style="text-align: center;margin-left: 1rem;">Web挖矿</span>
								</template>
								<div style="width: 80%;margin: auto;">
									<el-form label-position="top" label-width="80px" :rules="rules" ref="formdata" :model="formdata">
										<el-form-item label="钱包地址" prop="wallet"><el-input v-model="formdata.wallet" placeholder="请输入钱包地址"></el-input></el-form-item>
										<el-form-item>
											<center><el-button type="primary" @click="startWebMiner('formdata')">开始挖矿</el-button></center>
										</el-form-item>
									</el-form>
								</div>
							</el-collapse-item> -->
						</el-collapse>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div style="width: 80%;margin: auto;">
						<el-descriptions :title="$t('autominer.dqsb')" direction="vertical" :column="2" border>
							<el-descriptions-item :label="$t('autominer.dqllq')">
								<span id="brower">{{ info.llq }}</span>
							</el-descriptions-item>
							<el-descriptions-item :label="$t('autominer.dqxt')" size="medium">
								<span id="os">{{ info.os }}</span>
							</el-descriptions-item>
							<!-- <el-descriptions-item label="备注"><el-tag size="small">学校</el-tag></el-descriptions-item> -->

							<el-descriptions-item :label="$t('autominer.jianyi')" :contentStyle="{ 'text-align': 'center' }">
								<span id="suggest">{{ info.jy }}</span>
							</el-descriptions-item>
						</el-descriptions>
					</div>
				</el-col>
			</el-row>
		</div>
		<footerbar></footerbar>
	</div>
</template>

<script>
import footerbar from '../../toolbar/footer.vue';
import navbar from '../../toolbar/navbar.vue';
// import { startMining } from './web_miner/miner';
// var web_miner = require('./web_miner/miner');
var MobileDetect = require('mobile-detect');
var UA = require('ua-device');
import axios from 'axios';
var qs = require('qs');

export default {
	data() {
		var validatePass2 = (rule, value, callback) => {
			let walletcheck = /^[4|8]{1}([A-Za-z0-9]{105}|[A-Za-z0-9]{94})$/;
			console.log(value);
			if (value === '') {
				callback(new Error(this.$t('autominer.input_add')));
			} else if (!walletcheck.test(value)) {
				callback(new Error(this.$t('autominer.input_cadd')));
			} else {
				callback();
			}
		};
		return {
			activeName: '1',
			formdata: {
				os: 'win',
				wallet: '',
				minerName: 'default'
			},
			info: {
				llq: '',
				os: '',
				jy: ''
			},
			rules: {
				wallet: [{ required: true, message:this.$t('autominer.input_add'), trigger: 'blur' }, { validator: validatePass2, message: this.$t('autominer.input_cadd'), trigger: 'blur' }]
			}
		};
	},
	components: { footerbar, navbar },
	mounted() {
		this.pcInfo();
	},
	methods: {
		// startWebMiner(formName) {
		// 	this.$refs[formName].validate(valid => {
		// 		if (valid) {
		// 			console.log(this.formdata.wallet);
		// 			 startMining('c3pool.com', this.formdata.wallet, 'web_miner', navigator.hardwareConcurrency || 4, '');
		// 		} else {
		// 			this.$notify.error({
		// 				title: this.$t('autominer.err'),
		// 				message: this.$t('autominer.errmsg')
		// 			});
		// 			return false;
		// 		}
		// 	});
		// },
		onSubmit(formName) {
			let that = this;
			this.$refs[formName].validate(valid => {
				if (valid) {
					// console.log(this.activeName);
					var tmpOs = 'win';
					if (this.activeName === '1') {
						tmpOs = 'win';
					} else if (this.activeName === '2') {
						tmpOs = 'linux';
					} else if (this.activeName === '3') {
						tmpOs = 'mac';
					} else {
						this.$notify.warning({
							title: this.$t('autominer.warn'),
							message: this.$t('autominer.warnmsg')
						});
						return false;
					}
					var data = qs.stringify({
						wallet: this.formdata.wallet,
						os: tmpOs,
						minerName: this.formdata.minerName
					});
					var config = {
						method: 'post',
						url: 'https://napi.c3pool.org/down',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						},
						data: data,
						responseType: 'blob'
					};

					axios(config)
						.then(function(response) {
							that.download(tmpOs, response.data);
							// console.log(JSON.stringify(response.data));
						})
						.catch(function(error) {
							console.log(error);
						});
				} else {
					this.$notify.error({
						title: this.$t('autominer.err'),
						message: this.$t('autominer.errmsg2')
					});
					return false;
				}
			});
		},
		download(type, data) {
			if (!data) {
				return;
			}
			let url = window.URL.createObjectURL(new Blob([data]));
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			if ('win' === type) {
				link.setAttribute('download', 'xmrig.zip');
			} else {
				link.setAttribute('download', 'xmrig.tar.gz');
			}

			document.body.appendChild(link);
			link.click();
		},
		pcInfo() {
			var deviceType = navigator.userAgent; //获取userAgent信息
			var output = new UA(deviceType);
			this.info.llq = output.browser.name;
			let osname = output.os.name;
			if ('Windows' === osname) {
				this.info.os = osname;
				this.info.jy = this.$t('autominer.panel_win');
				this.activeName = '1';
				this.rules.os = 'win';
			} else if ('Linux' === osname || 'Ubuntu' === osname || 'Centos' === osname) {
				this.info.os = osname;
				this.info.jy = this.$t('autominer.panel_linux');
				this.activeName = '2';
				this.rules.os = 'linux';
			} else if ('Mac OS X' === osname) {
				this.info.os = osname;
				this.info.jy =this.$t('autominer.panel_mac');
				this.activeName = '3';
				this.rules.os = 'mac';
			} else if ('Android' === osname || 'iOS' === osname) {
				this.info.os = osname;
				this.info.jy =this.$t('autominer.panel_mobile');
				this.activeName = '2';
				this.rules.os = 'linux';
			} else {
				this.info.os = 'unkown';
				this.info.jy = this.$t('autominer.panel_ubknown');
				this.activeName = '4';
				this.rules.os = '';
			}

			// console.log(deviceType);
			// console.log(output);
		},
		mobileInfo() {
			var deviceType = navigator.userAgent; //获取userAgent信息
			document.write(deviceType); //打印到页面
			// console.log(deviceType);
			var md = new MobileDetect(deviceType); //初始化mobile-detect
			var os = md.os(); //获取系统
			var version = ''; //系统的版本号
			var model = ''; //设备型号
			if (os == 'iOS') {
				//ios系统的处理
				version = md.version('iPhone');
				os = md.os();
				model = md.mobile();
			} else if (os == 'AndroidOS') {
				//Android系统的处理
				os = md.os();
				version = md.version('Android');
				var sss = deviceType.split(';');
				var i = sss.contains('Build/');
				if (i > -1) {
					model = sss[i].substring(0, sss[i].indexOf('Build/'));
				}
			}
			//组装信息
			var info = {
				os: os, //系统类型
				version: version, //系统版本号
				model: model //设备型号
			};
			// console.log(info);
			return info;
		}
	}
};
</script>

<style scoped>
#box {
	background-color: white;
	width: 70%;
	margin: auto;
	margin-top: 5rem;
	padding-bottom: 2.5rem;
	margin-bottom: 5rem;
	border-radius: 0.5rem;
	box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, 0.1);
}
.my-label {
	background: #e1f3d8;
}

.my-content {
	background: #fde2e2;
}
</style>
